import { makeAutoObservable, runInAction } from "mobx";

import { loadOptions } from "./SettingsOptions";
import { SettingsSchemaLive } from "./SettingsSchemaLive";
import { SettingsSchemaValuebetsLive } from "./SettingsSchemaValuebetsLive";
import { SettingsStorage } from "./SettingsStorage";
export class SettingsStore {
  _load = true;
  options = {};
  settingsIdx = undefined; // selected settings index
  settingsList = [];
  storage = {};
  type; // live or valuebetsLive

  constructor(type) {
    this.type = type;
    makeAutoObservable(this);
  }

  get isLive() {
    return this.type === "live" || this.type === "valuebetsLive";
  }

  get isValuebetsLive() {
    return this.type === "valuebetsLive";
  }

  async load() {
    if (!this._load) return; // load only once
    this._load = false;
    const options = await loadOptions(this.type);
    runInAction(() => {
      this.options = options;
      this.storage = new SettingsStorage(this, this.type);
    });
    await this.storage.loadSettingsList();
  }

  get settings() {
    return this.settingsList[this.settingsIdx];
  }

  setSettingsById = (settingsId) => {
    const idx = this.settingsList.findIndex(settings => settings._id?.id === settingsId);
    if (idx !== -1) this.setSettingsIdx(idx);
  }

  setSettingsIdx = (settingsIdx) => this.settingsIdx = settingsIdx;

  setSettingsList = (settingsList) => this.settingsList = settingsList;

  // Return the correct settings schema
  get schema() {
    if (!this.options) return undefined;
    const availableSchemas = { live: SettingsSchemaLive, valuebetsLive: SettingsSchemaValuebetsLive };
    const Schema = availableSchemas[this.type];
    return new Schema(this.options);
  }

}
